import styled from 'styled-components';

const HEADER_HEIGHT = 64;

export const StyledWrapperContent = styled.div`
  min-height: calc(100vh - ${HEADER_HEIGHT}px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: ${HEADER_HEIGHT}px;
  background: linear-gradient(180deg, var(--sk-bg-primary) 0%, var(--sk-bg-secondary) 100%);
`;

export const StyledAppBar = styled.header`
  height: ${HEADER_HEIGHT}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--sk-bg-primary);
  border-bottom: 1px solid var(--sk-border-primary);
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--sk-cyan-500), transparent);
  }
`;

export const StyledBox = styled.div`
  flex-grow: 1;
`;

export const StyledInnerBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  flex-direction: column;
  padding: 0 24px;
`;

export const StyledDivider = styled.div`
  padding-top: 24px;
  width: 100%;
  border-bottom: 1px solid var(--sk-border-primary);
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
`;
